import { displayModes } from '../../constants';

import calendarHeaderUrl from './calendarHeader.html';

class CalendarHeaderCtrl {
  constructor(ShiftHeaderUtils, Authentication, dateFilter) {
    'ngInject';

    Object.assign(this, { ShiftHeaderUtils, Authentication, dateFilter });
  }

  $onInit() {
    this.refreshHours();
    this.goToDay = this.goToDay();

    this.deregisterOrgSettingsChanged = this.Authentication.onOrgSettingsChanged((current, old) => {
      if (
        old.visibleHoursStart !== current.visibleHoursStart ||
        old.visibleHoursEnd !== current.visibleHoursEnd
      ) {
        this.refreshHours();
      }
    });
  }

  $onDestroy() {
    this.deregisterOrgSettingsChanged();
  }

  refreshHours() {
    this.properHours = this.ShiftHeaderUtils.getProperHours();
    this.hours = this.ShiftHeaderUtils.getFormattedHours([...this.properHours]);
  }

  get forManager() {
    return this.type === 'manager';
  }

  isDayView() {
    return this.mode === displayModes.DAY;
  }

  isWeekView() {
    return this.mode === displayModes.WEEK;
  }

  isMonthView() {
    return this.mode === displayModes.MONTH;
  }

  getCurrentHour() {
    return Number(this.dateFilter(this.ShiftHeaderUtils.getCurrentDate(), 'HH'));
  }
}

export default {
  templateUrl: calendarHeaderUrl,
  controller: CalendarHeaderCtrl,
  controllerAs: 'ctrl',
  bindings: {
    mode: '<',
    processingMode: '<',
    type: '@',
    isTodaySelected: '<',
    currentDays: '<',
    currentAllDays: '<',
    notes: '<',
    goToDay: '&',
    openNotesModal: '&',
  },
};
